<template>

    <div>
        <van-nav-bar :title="title" >
        </van-nav-bar>
        <!--        <van-cell-group>-->
        <!--            <van-button style="margin-top: 10px;" type="default"-->
        <!--                        block round  :loading="isLoading"-->
        <!--                        loading-text="提交中..."-->
        <!--                        @click="show=true">通知</van-button>-->
        <!--        </van-cell-group>-->
        <van-cell-group>
            <van-cell title="零花钱" is-link to="pocketMoney" />
            <van-cell title="标签维护" is-link to="tagPage" />
            <van-cell title="字典维护" is-link to="sortPage" />
            <van-cell title="记录加班" is-link to="workOvertime" />
            <van-cell title="消息推送" is-link to="pushMsg" />
        </van-cell-group>
        <van-button style="margin-top: 10px;" type="warning" plain
                    block round  :loading="isClearRedis"
                    loading-text="清理中..."
                    @click="clearRedis">清空缓存</van-button>
        <van-button style="margin-top: 10px;" type="danger" plain
                    block round  :loading="isLoading"
                    loading-text="退出中..."
                    @click="logout">退出</van-button>
    </div>
</template>

<script>
    import store from '@/store'
    import * as types from '@/common/types/mutation.js'
    import * as MyApi from '../api/URLApiAddr.js'

    export default {
        name: "UserPage",
        data(){
            return {
                title:'我的',
                isLoading:false,
                show:false,
                isClearRedis: false
            }
        },
        methods: {
            logout(){
                store.commit(types.SYS+types.LOGOUT)
                store.commit(types.SYS + types.CLEAR_TOKEN)
                store.commit(types.SYS + types.CLEAR_USER)
                try{
                    let msg = {"token":"","type":"DEL"}
                    window.system.postMessage(JSON.stringify(msg));
                }catch (e) {

                }

                this.$router.push({path:"/pageLogin"})

            },
            clearRedis(){
                this.isClearRedis = true
                this.$axios.post(MyApi.CLEAR_REDIS).then((data) => {
                    if('200' == data.code){
                        this.$toast.success(data.msg);
                    }
                    this.isClearRedis = false

                }).catch((error) => {
                    this.isClearRedis = false
                    this.$toast.fail("清理异常");
                })
            }
        }
    }
</script>

<style scoped>

</style>
